export default {
  namespaced: true,
  state: {
    notification: {
      show: false,
      text: "",
      type: "info", // success, error, info, warning
      timeout: 4000
    }
  },
  mutations: {
    SHOW_NOTIFICATION(state, { text, type = "info", timeout = 4000 }) {
      state.notification.text = text;
      state.notification.type = type;
      state.notification.timeout = timeout;
      state.notification.show = true;
    },
    HIDE_NOTIFICATION(state) {
      state.notification.show = false;
    }
  },
  actions: {
    notify({ commit }, payload) {
      if (typeof payload === "string") {
        commit("SHOW_NOTIFICATION", { text: payload });
      } else {
        commit("SHOW_NOTIFICATION", payload);
      }
    },
    success({ dispatch }, text) {
      dispatch("notify", { text, type: "success" });
    },
    error({ dispatch }, text) {
      dispatch("notify", { text, type: "error" });
    },
    info({ dispatch }, text) {
      dispatch("notify", { text, type: "info" });
    },
    warning({ dispatch }, text) {
      dispatch("notify", { text, type: "warning" });
    }
  }
};
